import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { clearCargoNode } from "../../../../redux/reducer/raports.reducer";
import { TableActions } from "../../../../components/tables/tableContext/TableContext";
import { fetchCargoCar } from "../../../../redux/api/raports.api";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import TableWidget from "../../../../components/tables/TableWidget";
import {
  cargoTableHeader,
  getCargoTableData,
} from "./components/tableConfigs/cargoTableConfigs";
import CargoActionButton from "./components/TableActionsButtonsComponent/CargoActionButton";
import FinishDeliveryModal from "./components/FinishDeliveryModal";

function Cargo() {
  const dispatch = useAppDispatch();
  const { routeParams } = useRoutesHelper();

  const { idAuto, nrAuto } = routeParams;

  const {
    raports: {
      cargoNode: {
        data: { data: cargoNode, total: totalCargoNode },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    raports: state.raports,
  }));

  const handleTableActions = (action: TableActions) => {
    if (action.tablePagination.page && action.tablePagination.rowsPerPage) {
      dispatch(
        fetchCargoCar({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          idAuto: idAuto,
        }),
      );
    }
  };

  useEffect(() => {
    return () => {
      dispatch(clearCargoNode());
    };
  }, [dispatch]);

  return (
    <>
      <FinishDeliveryModal />

      <TableWidget
        tableTitle={`Marfa din masina ${nrAuto}`}
        tableHeaderData={cargoTableHeader}
        tableItemsData={getCargoTableData(cargoNode)}
        tableLoading={isLoading}
        handleTableActions={handleTableActions}
        ActionButtonsComponent={CargoActionButton}
        totalItems={totalCargoNode}
        borderedRow
      />
    </>
  );
}

export default Cargo;
